import React from 'react';
import { Div, Typography, Circle } from '@icecreamsocial/components';
import { GiftCardIcon } from '../SupportedIcons';

export const Offer = ({ heading, description, caption, title, children }) => {
	return (
		<>
			<Div textAlign="center">
				<Typography.H1>{heading}</Typography.H1>
			</Div>

			<Div
				position="relative"
				borderRadius="default"
				padding={['md', 'lg']}
				marginTop="xlg"
				marginBottom="md"
				backgroundColor="ambient"
			>
				<Typography.P>{description}</Typography.P>
			</Div>
		</>
	);
};
